import type { IconData } from '@stacksjs/iconify-core'

export const oneFingerTapSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 14a9 9 0 1 1 18 0a2 2 0 1 0 4 0c0-7.18-5.82-13-13-13S7 6.82 7 14a2 2 0 1 0 4 0m7.298-5.383a11.2 11.2 0 0 1 2.943-.021c2.176.283 3.553 2.204 3.74 4.266c.224 2.493.504 5.94.539 8.005l.993.203c2.412.487 5.605 1.133 8.276 2.313c1.617.714 3.093 1.644 4.101 2.896c1.023 1.269 1.545 2.845 1.281 4.782c-.3 2.2-.87 5.077-1.946 8.37c-1.024 3.133-3.742 5.378-7.022 5.75c-3.88.438-7.804.425-11.68-.075c-2.823-.363-5.438-1.829-6.776-4.427c-1.061-2.06-2.213-5.08-2.88-9.231c-.321-2.01.475-3.992 1.933-5.356l2.699-2.523c.003-5.228.132-8.69.26-10.841c.12-2.008 1.455-3.814 3.539-4.11\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default oneFingerTapSolid
